// const HOST = "http://localhost:3031/";
const HOST = "https://denisapi.appdeft.in/";
// const HOST = "https://apiv2.denis-kebap.at/";
// const HOST = "http://192.168.10.120:3032/";

const SOCKET_URL = HOST;
const BASE_URL = HOST + "api/user";

export { BASE_URL, HOST, SOCKET_URL };
